module.exports = __webpack_public_path__ + "img/6.fee96c95.jpg";